import { render, staticRenderFns } from "./CDRQDocument.vue?vue&type=template&id=2d20625c&scoped=true&"
import script from "./CDRQDocument.vue?vue&type=script&lang=ts&"
export * from "./CDRQDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d20625c",
  null
  
)

export default component.exports